import { useEffect, useState } from "react";
import axiosInstance from "../axios/axiosInstance";

export interface WeatherData {
  weatherCode: number;
  temperature: number;
  sunrise: string;
  sunset: string;
  localTime: string;
}

export const useWeather = () => {
  const [weather, setWeather] = useState<WeatherData>({} as WeatherData);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get<WeatherData>(
        "/v1/location/weather"
      );
      console.log(response);

      setWeather(response.data);
    } catch (err) {
      console.error("Błąd podczas pobierania danych:", err);
      setError("Wystąpił błąd podczas pobierania danych");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetch = () => {
    fetchData();
  };

  return { weather, loading, error, refetch };
};
